export default __webpack_public_path__ + "static/media/dao.06f4542b.png";